/* eslint-disable security/detect-object-injection */
import React from 'react';
import { toast } from 'sonner';

export const _showToast = (
    heading: string,
    description: string | React.ReactNode,
    type: 'error' | 'success' | 'info' | 'warning',
    duration?: number
) => {
    if (typeof toast[type] === 'function') {
        toast[type](
            <div className='toast' role='alert'>
                <div className='toast-header'>
                    <h4>{heading}</h4>
                    <button className='toast-close' onClick={() => toast.dismiss()}></button>
                </div>
                <div className='toast-body'>
                    {typeof description === 'string' ? <span dangerouslySetInnerHTML={{ __html: description }} /> : description}
                </div>
            </div>,
            { duration: duration }
        );
    }
};
